export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const CLEAR_STATE = 'CLEAR_STATE';
